import { ProductProps } from '../../type'
import { ProductCategory, ProductTag } from '../../enum'
import imageBanner from './img/banner.png'
import imageTable from './img/table.jpg'
import imageCertificate1 from './img/certificate-1.jpg'

export const phgEss5l20l: ProductProps = {
  tag: ProductTag.ESS,
  category: ProductCategory.CommercialEnergyStorageSystems,
  pathName: 'phg-ess-5l-20l',
  banner: imageBanner,
  title: 'Smart Split-phase Hybrid Inverter\nPhG-P510K0L',
  description:
    'PhaseGreen PhG-P5-10KOLNA-M brings PV energy storage solutions to\nAmerican customers with safe performance and first-class quality',
  features: [
    {
      type: 'card-list',
      content: [
        {
          icon: 'safety',
          title: 'Friendly capacity options',
          description: [
            'Stackable module design based on capacity of 5kWh, expandable to 60kWh with 3 systems of 20kWhin parallel',
          ],
        },
        {
          icon: 'safety',
          title: 'Easy to install',
          description: ['Easy plug-in and ready to use, light-weighted system with less manpower to install'],
        },
        {
          icon: 'safety',
          title: 'Excellent low temp. performance (Optional)',
          description: ['No degradation in performance at -10°C'],
        },
        {
          icon: 'safety',
          title: 'Smart battery EMS',
          description: [
            'Real-time monitoring in control of safe and reliable operation, no boundary to remotely upgrade system for maintenance',
          ],
        },
      ],
    },
  ],
  specImages: [imageTable],
  certificateImages: [imageCertificate1],
}
